var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex text-center",class:_vm.justifyContent,style:({
    'justify-content': _vm.justify,
  })},[_c('InlineRow',[_c('b-spinner',{style:({
        width: _vm.width,
        height: _vm.height,
      }),attrs:{"variant":_vm.variant,"small":_vm.small}}),_vm._t("complement",function(){return [(_vm.withLoadingText)?_c('label',{staticClass:"ml-5"},[_vm._v(_vm._s(_vm.loadingText))]):_vm._e()]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }